import React from 'react';
import _ from 'lodash';
import slugify from 'slugify';

import { TableData, TableRow } from '~components/common/Table';
import { rowRendererProps } from '../propTypes';
import { RowDataRenderer } from './default';
import DeadlineRelative from '../../common/DeadlineRelative';

export default function BallotReturnMethodsRowRenderer({ state }) {
  const stateName = state.fieldValue;
  const stateSlug = slugify(stateName.toLowerCase());
  const stateData = _.keyBy(state.nodes, 'field_type');

  const ballotReturnLocations = stateData.ballot_return_locations
    ? stateData.ballot_return_locations.multiselect_value
    : [];

  return (
    <TableRow>
      <TableData>
        <a
          href={`/how-to-vote/${stateSlug}/`}
          title={`How to vote in ${stateName}`}
        >
          {stateName}
        </a>
      </TableData>
      <RowDataRenderer
        columns={[
          {
            title: 'Hand-delivery options',
            valueNode: (
              <ul>
                <li>
                  <strong>Dropbox: </strong>
                  {ballotReturnLocations.includes('drop_box') ? 'Yes' : 'No'}
                </li>
                <li>
                  <strong>Election office: </strong>
                  {ballotReturnLocations.includes('local_election_office')
                    ? 'Yes'
                    : 'No'}
                </li>
                <li>
                  <strong>Early voting location: </strong>
                  {ballotReturnLocations.includes('early_voting_site')
                    ? 'Yes'
                    : 'No'}
                </li>
                <li>
                  <strong>Polling place: </strong>
                  {ballotReturnLocations.includes('polling_place')
                    ? 'Yes'
                    : 'No'}
                </li>
              </ul>
            ),
          },
          {
            title: 'Hand-delivered ballot return deadline',
            valueNode: (
              <div>
                <DeadlineRelative
                  relativeDeadline={stateData.ballot_return_deadline_in_person}
                />
              </div>
            ),
          },
          {
            title: 'Mailed ballot return deadline',
            valueNode: (
              <div>
                <DeadlineRelative
                  relativeDeadline={stateData.ballot_return_deadline_mail}
                />
              </div>
            ),
          },
        ]}
      />
    </TableRow>
  );
}

BallotReturnMethodsRowRenderer.propTypes = rowRendererProps;
